import { DataLoader } from 'src/app/services/data-loader/data-loader';
import { DataLoaderResult } from '../../../services/data-loader/data-loader-result';
import { standardRun } from '../../../services/data-loader/utils/standard-run';
import { Factory } from 'src/app/utils/Factory';
import { ICreatedInstanceId, IQueryCacheService } from 'src/app/utils/IFactory';
import { QueryCacheService } from 'src/app/services/query-cache.service';
import { bq2echartsformat } from 'src/app/utils/echarts/echarts';
import { currentDataProject } from 'src/app/services/data-project/models/data-project.model';

export class FakeDatetimeDataDataLoaderFactoryOptions
    implements ICreatedInstanceId, IQueryCacheService
{
    constructor(
        public createdInstanceId: string,
        public queryCacheService: QueryCacheService
    ) {}
}

export class FakeDatetimeDataDataLoaderFactory extends Factory<
    DataLoader,
    FakeDatetimeDataDataLoaderFactoryOptions
> {
    override FACTORY_CLASS: string = 'FakeDatetimeDataDataLoaderFactory';

    override getInstance(
        options: FakeDatetimeDataDataLoaderFactoryOptions
    ): DataLoader {
        return new DataLoader(options.createdInstanceId, async function (
            queryContext,
            cancellationToken
        ) {
            const process = async () => {
                this.emitter.emit(
                    DataLoaderResult.getLoading(this.latestData, queryContext)
                );

                const query = `
-- DataLoaderId: ${this.instanceId}
SELECT date, fake_float_large, fake_integer_xlarge, fake_fraction_middle, fake_fraction_small
FROM \`${currentDataProject().gcpProjectId}.dev.fake_datetime_data\`
ORDER BY date
`;

                const queryResponse = await DataLoader.runQuery(
                    query,
                    options.queryCacheService
                );
                cancellationToken.throwIfCancellationRequested();

                const data = [...queryResponse.result];
                this.latestData = data;
                bq2echartsformat(data);

                this.emitter.emit({
                    data: this.latestData,
                    queryContext,
                    status: 'ok',
                    statusMessage: '',
                    isLoading: false,
                    sqlAndJsProcessing: query,
                });
            };

            await standardRun(this, queryContext, process);
        });
    }
}
